/* globals axios turnstile */
import Vue from 'vue';
import Errors from '../classes/Errors';

Vue.component('job-form-component', {
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            asset: null,
        };
    },

    mounted() {
        this.loadTurnstile();
    },

    methods: {
        loadTurnstile() {
            // explicit render call
            // if using synchronous loading, will be called once the DOM is ready
            turnstile.ready(() => {
                turnstile.render('.cf-turnstile', {
                    sitekey: '0x4AAAAAAAENIOZe-yiq8mTz',
                    // callback(token) {
                    //     console.log(`Challenge Success ${token}`);
                    // },
                });
            });
        },

        onSubmit(event) {
            const form = event.currentTarget;

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            axios
                .post('/', new FormData(form))
                .then((response) => {
                    this.submitting = false;
                    const result = response.data;

                    if (result.data.errors) {
                        this.errors.clear();
                        this.errors.record(result.data.errors);
                        return;
                    }

                    // Success
                    this.formCompleted = true;
                    this.errors.clear();

                    // window.location = this.$refs.redirectUrl.value;
                })
                .catch((error) => {
                    console.log(error);
                    this.submitting = false;
                    console.log(error.response);
                });
        },

        jobApplicationFileChanged(asset) {
            this.asset = asset;
        },
    },
});
